import { type HttpError, teamsClient } from '@atlaskit/teams-client';

import type { StoreApi } from '../types';

export const getTeamProfile =
	(teamId: string) =>
	async ({ setState }: StoreApi): Promise<void> => {
		setState({
			teamProfile: {
				teamId,
				isLoading: true,
				hasLoaded: false,
				errorType: null,
				data: {},
			},
		});

		try {
			const team = await teamsClient.getTeamById(teamId);

			setState({
				teamProfile: {
					teamId,
					isLoading: false,
					hasLoaded: true,
					errorType: null,
					data: team,
				},
			});
		} catch (e) {
			setState({
				teamProfile: {
					teamId,
					isLoading: false,
					hasLoaded: true,
					errorType: e as HttpError,
					data: {},
				},
			});
		}
	};
